import { render, staticRenderFns } from "./ModalDetalheAptidao.vue?vue&type=template&id=37a39b22&lang=pug"
import script from "./ModalDetalheAptidao.vue?vue&type=script&lang=js"
export * from "./ModalDetalheAptidao.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalheAptidao.vue?vue&type=style&index=0&id=37a39b22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports